module.exports = __webpack_public_path__ + "static/media/BigNameHeader.5819e481.gif";